import firebase from "firebase";

const app = firebase.initializeApp({
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
});

export const storage = app.storage();
